/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#content[_ngcontent-%COMP%]{font-family:Poppins!important}@keyframes skeleton-animation{0%{background-position:-200px 0}to{background-position:calc(200px + 100%) 0}}.skeleton-loader[_ngcontent-%COMP%]{animation:1.2s ease-in-out infinite skeleton-animation;background-color:#eee;background-image:linear-gradient(90deg,#eee,#f5f5f5,#eee);background-repeat:no-repeat;background-size:200px 100%;height:150px;margin-bottom:10px}"];
export { styles as styles };
